module.exports = __webpack_public_path__ + "static/media/3dcommerce.23f6c5ca.jpg";